<p-table
  [value]="companies"
  dataKey="id"
  [expandedRowKeys]="expandedRows"
  (onRowExpand)="onRowExpand($event)"
  (onRowCollapse)="onRowCollapse($event)"
  [rowHover]="true"
>
  <ng-template #caption>
    <div class="flex justify-end">
      <p-button
        icon="pi pi-plus"
        label="Nuova Azienda"
        [rounded]="true"
        severity="success"
        [outlined]="true"
        (click)="createCompany.emit()"
      />
    </div>
  </ng-template>

  <ng-template #header>
    <tr>
      <th style="width: 3.5rem"></th>
      <th>Azienda</th>
      <th>Codice</th>
      <th>Partita IVA</th>
      <th>Contatti</th>
      <th style="width: 8rem"></th>
    </tr>
  </ng-template>

  <ng-template #body let-company let-expanded="expanded">
    <tr>
      <td>
        <p-button
          [pRowToggler]="company"
          [text]="true"
          [rounded]="true"
          severity="secondary"
          size="small"
          [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
        />
      </td>
      <td>
        <div class="flex items-center gap-3">
          <div
            class="w-9 h-9 rounded-full flex items-center justify-center text-xs font-bold shrink-0 select-none"
            [ngStyle]="getCompanyAvatarStyle(company)"
          >{{ getCompanyInitials(company) }}</div>
          <div>
            <div class="font-medium text-sm">{{ company.name }}</div>
          </div>
        </div>
      </td>
      <td class="text-sm text-muted-color">{{ company.code || '—' }}</td>
      <td class="text-sm text-muted-color">{{ company.vatNumber || '—' }}</td>
      <td class="text-sm text-muted-color">
        {{ company.contacts?.length ?? 0 }}
        {{ (company.contacts?.length ?? 0) === 1 ? 'contatto' : 'contatti' }}
      </td>
      <td>
        <div class="flex gap-1 justify-end">
          <p-button
            icon="pi pi-pencil"
            [text]="true"
            [rounded]="true"
            severity="secondary"
            size="small"
            pTooltip="Modifica"
            tooltipPosition="top"
            (click)="editCompany.emit(company); $event.stopPropagation()"
          />
          <p-button
            icon="pi pi-trash"
            [text]="true"
            [rounded]="true"
            severity="danger"
            size="small"
            pTooltip="Elimina"
            tooltipPosition="top"
            (click)="deleteCompany.emit(company); $event.stopPropagation()"
          />
        </div>
      </td>
    </tr>
  </ng-template>

  <!-- Expanded row: contacts sub-table -->
  <ng-template #expandedrow let-company>
    <tr style="background: #f8fafc !important;">
      <td colspan="6" class="p-0" style="background: #f8fafc !important;">
        <div class="w-full">

          <p-table [value]="company.contacts ?? []" dataKey="id" [rowHover]="true">
            <ng-template #header>
              <tr>
                <th>Nome</th>
                <th>Email</th>
                <th>Telefono</th>
                <th>Operatori</th>
                <th>Teams</th>
              </tr>
            </ng-template>
            <ng-template #body let-contact>
              <tr>
                <td>
                  <div class="flex items-center gap-3">
                    <div
                      class="w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold shrink-0 select-none"
                      [ngStyle]="getContactAvatarStyle(contact)"
                    >{{ getContactInitials(contact) }}</div>
                    <span class="text-sm font-medium">{{ contact.firstName }} {{ contact.lastName }}</span>
                  </div>
                </td>
                <td class="text-sm text-muted-color">{{ contact.email || '—' }}</td>
                <td>
                  @if (contact.phoneNumbers?.length) {
                    <div class="flex items-center gap-2">
                      <span class="text-sm text-muted-color">{{ primaryPhone(contact) }}</span>
                      @if (contact.phoneNumbers.length > 1) {
                        <span class="text-xs font-medium px-1.5 py-0.5 rounded-full bg-surface-100 text-muted-color">
                          +{{ contact.phoneNumbers.length - 1 }}
                        </span>
                      }
                    </div>
                  } @else {
                    <span class="text-sm text-muted-color">—</span>
                  }
                </td>
                <td>
                  @if (contact.operators?.length) {
                    <div class="flex items-center">
                      @for (user of contact.operators.slice(0, 5); track user.id) {
                        <div
                          class="w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold border-2 border-surface-0 -ml-1.5 first:ml-0 select-none cursor-default"
                          [style.background]="getUserAvatarStyle(user).background"
                          [style.color]="getUserAvatarStyle(user).color"
                          [pTooltip]="getUserDisplayName(user)"
                          tooltipPosition="top"
                        >{{ getUserInitials(user) }}</div>
                      }
                      @if (contact.operators.length > 5) {
                        <div
                          class="w-7 h-7 rounded-full flex items-center justify-center text-xs font-semibold border-2 border-surface-0 -ml-1.5 bg-surface-200 text-muted-color"
                          [pTooltip]="'+' + (contact.operators.length - 5) + ' altri'"
                          tooltipPosition="top"
                        >+{{ contact.operators.length - 5 }}</div>
                      }
                    </div>
                  } @else {
                    <span class="text-sm text-muted-color">—</span>
                  }
                </td>
                <td>
                  @if (contact.teams?.length) {
                    <div class="flex flex-wrap items-center gap-1">
                      @for (team of contact.teams.slice(0, 1); track team.id) {
                        <span
                          class="inline-flex items-center px-2 py-0.5 rounded-md text-xs font-medium bg-surface-100 text-color border border-surface-300 whitespace-nowrap select-none"
                          [pTooltip]="getTeamMembersTooltip(team)"
                          tooltipPosition="top"
                        >{{ team.name }}</span>
                      }
                      @if (contact.teams.length > 1) {
                        <span
                          class="text-xs font-medium px-1.5 py-0.5 rounded-full bg-surface-100 text-muted-color select-none"
                          [pTooltip]="getExtraTeamsTooltip(contact)"
                          tooltipPosition="top"
                        >+{{ contact.teams.length - 1 }}</span>
                      }
                    </div>
                  } @else {
                    <span class="text-sm text-muted-color">—</span>
                  }
                </td>
              </tr>
            </ng-template>
            <ng-template #emptymessage>
              <tr>
                <td colspan="5">
                  <div class="flex flex-col items-center justify-center py-16 gap-3 text-muted-color">
                    <i class="fa-light fa-inbox text-4xl opacity-40"></i>
                    <span class="text-sm">Nessun elemento trovato in questa sezione</span>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>

        </div>
      </td>
    </tr>
  </ng-template>

  <ng-template #emptymessage>
    <tr>
      <td colspan="6">
        <div class="flex flex-col items-center justify-center py-16 gap-3 text-muted-color">
          <i class="fa-light fa-inbox text-4xl opacity-40"></i>
          <span class="text-sm">Nessun elemento trovato in questa sezione</span>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>
